export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./CatalogMenu.vue?vue&type=template&id=16f1eb94"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Catalogs/RoadConceptsAdvance/CatalogMenu.vue?vue&type=template&id=16f1eb94
// module id = 2185
// module chunks = 31